import { SearchCriteria } from "./search-criteria";

export class GetGymClassDetailAppointmentsSearchCriteria extends SearchCriteria {
  public GymClassDetailId: number;
  public GymClientMembershipId: number;
  public GymClientMembershipClassId: number;
}
